import { render, staticRenderFns } from "./SimDesactivadoresForm.vue?vue&type=template&id=5e5b2120&scoped=true&"
import script from "./SimDesactivadoresForm.vue?vue&type=script&lang=ts&"
export * from "./SimDesactivadoresForm.vue?vue&type=script&lang=ts&"
import style0 from "./SimDesactivadoresForm.vue?vue&type=style&index=0&id=5e5b2120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5b2120",
  null
  
)

export default component.exports